/*eslint-disable */
import { useEffect, useState } from 'react';
import { ExternalLink, Plus } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { analyticsAction, modalActions } from '@/Actions';
import {
	addCommas, baseUnits, capitalizeFirstLetter, getBase64FromFileBlob, getBase64FromFileUrl, getPODeltas, getUnitConvertedQuantity, getUnitConvertedUnit, handleOrderStatus, inputHelper, keyPressHandler, useProductData, useQuery
} from '@/Helpers';
import { urls } from '@/Constants';
import useKeyPress from '@/Helpers/useKeyPress';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { AlertModal } from '@/Components/Modals';
import { notificationServices } from '@/Services';
import CreateShipmentModal from '../Inventory Analytics/Shipment/createShipmentModal';
import GrnHeader from '@/Pages/GRNPage/grnHeader';
import Tab from '@/Components/InfoTab/tab';
import GrnTable from '@/Pages/GRNPage/GrnTable';
import Info from '@/Components/InfoTab/Info';
import DocumentsImagesSection from '../Inventory Analytics/PurchaseOrderList/DocumnetSection';
import { DocumentModal } from '../Inventory Analytics/PurchaseOrderList/docModal';
import utilsServices from '@/Services/utilsServies.services';
import { FileUploaderModal } from '@/Components/Modals/FileUploaderModal';

const tabList = [
	{
		label: 'Ordered Products',
		value: 'orderedProducts',
	},
	{
		label: 'Shipments',
		value: 'shipment',
	},
	{
		label: 'Documents',
		value: 'documents',
	},
];

const fieldsMap = {
	'Client Po': 'clientPoId',
	'Delivery From': 'deliveryFrom',
	Buyer: 'buyer',
	Shipment: 'shipments',
	'PO Type': 'poType',
	'Order Date': 'orderDate',
	'Dispatch Date': 'scheduledAt',
	'Created By': 'createdBy',
	'Order Value': 'orderValue',
	// 'Extra Charges + Delivery Charges': 'shipmemtAmount',
};
function BuyerSalesDetails() {
	const search = useQuery();
	const history = useHistory();
	const location = useLocation();
	const poId = Number(search.get('poId'));
	const buyerList = useSelector((state) => state?.analytics?.INVENTORY_ANALYTICS?.BUYER_ORDERS_LIST);
	const buyerData = buyerList.find((item) => item?.id === poId);
	const keyPressed = useKeyPress();
	const [tabValue, setTabValue] = useState('');
	const [po, setPo] = useState({});
	const [data, setData] = useState([]);
	const [idx, setIdx] = useState(-1);
	const [poInfo, setPoInfo] = useState({});
	const [shipmentList, setShipmentList] = useState({});
	const dispatch = useDispatch();
	const formatDate = (date) => (date ? moment(date).format('Do MMMM YY') : 'N/A');
	const backUrl = history?.location?.state?.prevPath || urls?.EXTENSION + urls?.BUYER_SALES_ORDER;
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);

	useEffect(() => {
		// if (Array.isArray(products) && products?.length === 0) {
		useProductData(dispatch);
		// }
	}, []);

	const fetchShipmentsList = async () => {
		try {
			const response = await inventoryAnalyticsServices?.Shipmentlist({
				req: {
					data: {
						filters: {
							poId: Number(poId),
						},
					},
				},
			});

			if (response?.statusCode === 200) {
				setShipmentList({
					total: response?.total || 0,
					data: response?.data || [],
				});
			}
		} catch (error) {
			console.error('Error fetching shipment list:', error);
		}
	};

	useEffect(() => {
		setPo(buyerData);
		fetchShipmentsList();
	}, [poId]);

	// const handleShipmentAmount = () => {
	// 	if (!shipmentList?.data?.length) return 0;

	// 	const total = shipmentList.data.reduce((acc, shipment) => {
	// 		const deliveryCharge = shipment.deliveryCharges || 0;
	// 		const deliveryTax = (deliveryCharge * (shipment.deliveryTaxPercentage || 0)) / 100;

	// 		const packagingCharge = shipment.packagingCharges || 0;
	// 		const packagingTax = (packagingCharge * (shipment.packagingTaxPercentage || 0)) / 100;

	// 		const additionalCharges =
	// 			shipment.extraData?.[0]?.jsonData?.additionalCharges || [];

	// 		const additionalChargeTotal = additionalCharges.reduce((sum, charge) => {
	// 			const price = charge?.price || 0;
	// 			return sum + price;
	// 		}, 0);

	// 		return (
	// 			acc +
	// 			deliveryTax +
	// 			packagingTax +
	// 			additionalChargeTotal
	// 		);
	// 	}, 0);

	// 	return total.toFixed(2);
	// };

	const fetchpo = async () => {
		try {
			const response = await inventoryAnalyticsServices.fetchPo(poId);
			if (response?.statusCode === 200) {
				return response?.data;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const afterShipmentSave = async () => {
		const updatedPo = await fetchpo();
		setPo(updatedPo);
		fetchShipmentsList();
	};

	useEffect(async () => {
		if (!po) {
			const updatedPo = await fetchpo();
			setPo(updatedPo);
			setTabValue('orderedProducts');
			setData(updatedPo?.items || []);
			setPoInfo({
				id: updatedPo?.id,
				clientPoId: updatedPo?.clientPoId,
				deliveryFrom: updatedPo?.fromStoreName || 'N/A',
				buyer: updatedPo?.vendorName || 'N/A',
				shipments: shipmentList?.total ?? 'N/A',
				createdBy: updatedPo?.initiatedByName || 'N/A',
				orderValue: updatedPo,
				orderDate: formatDate(updatedPo?.createdAt),
				scheduledAt: formatDate(moment(updatedPo?.scheduledAt, ['DD/MM/YYYY', moment.ISO_8601]).isValid() ? moment(updatedPo?.scheduledAt, ['DD/MM/YYYY', moment.ISO_8601]) : null),
				poType: updatedPo,
				// shipmemtAmount: handleShipmentAmount(),
			});
			return;
		}
		setTabValue('orderedProducts');
		setData(po?.items || []);
		setPoInfo({
			id: po?.id,
			clientPoId: po?.clientPoId,
			deliveryFrom: po?.fromStoreName || 'N/A',
			buyer: po?.vendorName || 'N/A',
			shipments: shipmentList?.total ?? 'N/A',
			createdBy: po?.initiatedByName || 'N/A',
			orderValue: po,
			orderDate: formatDate(po?.createdAt),
			scheduledAt: formatDate(po?.scheduledAt),
			poType: po,
			// shipmemtAmount: handleShipmentAmount(),
		});
	}, [po, shipmentList]);

	const handleDeleteDocument = async (id) => {
		const req = {
			data: {
				poId: id,
			}
		}
		try {
			const response = await inventoryAnalyticsServices.deleteDocument(req)
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					type: 'success',
					message: 'Document deleted successfully',
				})
				dispatch(modalActions?.toggleAlert(false));
				dispatch(modalActions?.toggleDocumentModal(false));
				const updatedPo = await fetchpo();
				setPo(updatedPo);
				dispatch(analyticsAction.updateBuyerList(idx, updatedPo));
			}
		} catch (error) {
			notificationServices?.generateNotification({
				type: 'error',
				message: error?.message || error,
			})
		}
	}

	const handleAlertModal = async (id) => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: 'Delete Proof of delivery Document',
			message: `Are you sure you want to delete this document of this SO ID ${id}?`,
			handleConfirm: () => handleDeleteDocument(id),
		}));
	}

	const handleViewDoc = (document, documents) => {
		dispatch(modalActions?.toggleDocumentModal(true, {
			obj: document, list: documents, handleDelete: handleAlertModal,
		}));
	};

	const handleDocData = async () => {
		const urls = [];
		let docData = [];
		const docFields = {
			deliveryChallanURL_db: po?.deliveryChallanURL_db,
			invoiceURL_db: po?.invoiceURL_db,
			grnURL_db: po?.grnURL_db,
			woDocUrl_db: po?.woDocUrl_db,
			poURL_db: po?.poURL_db,
			doc_db_url: po?.jsonData?.buyerUploadedDoc?.doc_db_url,
		};
		docData = Object.values(docFields).filter((url) => url != null && url !== undefined && url !== '');
		try {
			const response = await utilsServices?.getBase64FromFileUrl({
				data: {
					docUrls: docData,
				},
			});

			if (response?.statusCode === 200) {
				Object.entries(response?.data).forEach(([key, value]) => {
					const name = key.split(':')[1];
					const downloadableUrlKey = Object?.entries(docFields)?.find(([k, v]) => v && key && v.includes(key))?.[0].split('_')[0];
					if (docFields?.doc_db_url === key) {
						urls.push({
							name: po?.jsonData?.buyerUploadedDoc?.fileName,
							type: '',
							uploadedDate: po?.jsonData?.buyerUploadedDoc?.uploadedAt,
							base64url: value,
							url: po?.jsonData?.buyerUploadedDoc?.url,
							podId: po?.jsonData?.buyerUploadedDoc?.podId,
							delete: true,
							id: po?.id || poId,
						})
					} else {
						urls.push({
							name,
							type: '',
							uploadedDate: po?.createdAt,
							base64url: value,
							url: po?.[downloadableUrlKey],
						});
					}
				});
				setData(urls);
			}
		} catch (error) {
			setData([]);
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleTabChange = (value) => {
		setTabValue(value);
		if (value === 'orderedProducts') {
			setData(po?.items);
		} else if (value === 'documents') {
			handleDocData();
		}
	};

	const handleButtons = () => {
		const fullFilled = po?.items?.reduce((acc, curr) => acc + curr?.fulfilled, 0);
		const status = po?.orderStatus;

		return buttons?.filter((item) => {
			if (status === 'PENDING') {
				if (item.label === 'Cancel Po') return true;
				if (item.label === 'Close PO') return fullFilled > 0;
				if (item.label === 'Add Shipment') return true;
			}
			if (status === 'TRANSIT' && !po?.jsonData?.buyerUploadedDoc && shipmentList?.data?.length === 0) {
				if (item.label === 'Upload POD Document') return true;
			}
		});
	};

	const openShipmentModal = () => {
		dispatch(modalActions.toggleCreateShipmentModal(true, po));
	};

	const handlePoStatus = (id, status) => {
		// eslint-disable-next-line no-console
		const statusText = status === 'CANCEL' ? 'Cancelling' : 'Closing';
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `${statusText}  Po ${id || ''}`,
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status,
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				const updatedPo = await fetchpo();
				setPo(updatedPo);
				dispatch(modalActions?.toggleAlert(false));
				dispatch(analyticsAction.updateBuyerList(idx, updatedPo));
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleClose = () => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: 'Close PO',
			handleConfirm: () => {
				handlePoStatus(poId, 'CLOSE');
			},
			colorReverse: true,
			cancelText: 'No',
			confirmText: 'Yes',
			message: `Are you sure you to close po-${poId || ''
				}?`,
		}));
	};

	const handleCancel = () => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: 'Cancel PO',
			handleConfirm: () => {
				handlePoStatus(poId, 'CANCEL');
			},
			colorReverse: false,
			cancelText: 'No',
			confirmText: 'Yes',
			message: `Are you sure you to cancel ${poId || ''
				}?`,
		}));
	};

	const getDisable = () => {
		if (shipmentList?.data?.length === 0) {
			const orderfullied = po?.items?.some((item) => item?.fulfilled > 0);
			if (orderfullied) {
				return {
					isDisable: true, infoText: 'Shipment has already been fulfilled using non Shipment flow',
				};
			}
			return {
				isDisable: false, infoText: '',
			};
		}
		if (shipmentList?.data?.length > 0) {
			const isTransit = shipmentList?.data?.some((item) => ['PACKAGING', 'DISPATCH']?.includes(item?.status));
			if (isTransit) {
				return {
					isDisable: true, infoText: 'Shipment can only be Created if the existing Shipments are dispatched',
				};
			}
			return {
				isDisable: false, infoText: '',
			};
		}
	};

	const handleOpenDocumentModal = () => {
		dispatch(modalActions.toggleFileUploaderModal(true, {
			heading: 'Upload Document',
			id: poId,
			showInput: true,
			inputInfo: {
				label: 'POD ID',
				placeholder: 'Enter POD ID',
				mandatory: true,
			},
		}));
	}
	const handleDocUpload = async (file, id, podId) => {
		const req = {
			data: {
				id,
				uploadDoc: file,
				podId: podId,
			}
		}
		try {
			const response = await inventoryAnalyticsServices.uploadDocument(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				dispatch(modalActions.toggleFileUploaderModal(false));
				const updatedPo = await fetchpo();
				setPo(updatedPo);
				dispatch(analyticsAction.updateBuyerList(idx, updatedPo));
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message,
			});
		}
	};
	const buttons = [
		{
			label: 'Upload POD Document',
			noLevelSpecific: true,
			handleClick: handleOpenDocumentModal,
			style: 'border border-blue-400 bg-transparent',
		},
		{
			label: 'Close PO',
			noLevelSpecific: true,
			handleClick: handleClose,
			style: 'bg-slate-100',
		},
		{
			label: 'Cancel Po',
			handleClick: handleCancel,
			style: 'text-red-700 border-red-700',
		},
		{
			label: 'Add Shipment',
			icon: <Plus size={16} />,
			handleClick: openShipmentModal,
			style: 'bg-yellow-500',
			disabled: getDisable()?.isDisable,
			infoText: getDisable()?.infoText,
		},
	];

	useEffect(() => {
		if (buyerList?.length > 0) {
			const currentIndex = buyerList.findIndex(
				(item) => item.id === poId
			);
			setIdx(currentIndex);
		}
	}, [poId, buyerList]);

	const navigateQc = (e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;

		if (dataset.type === 'next') {
			newListItem = buyerList?.[idx + 1];
		} else {
			newListItem = buyerList?.[idx - 1];
		}

		if (newListItem) {
			history.push({
				pathname: `${urls.EXTENSION}${urls.BUYER_SALES_DETAILS}`,
				search: `poId=${newListItem?.id}&clientPoId=${newListItem?.clientPoId}`,
				state: {
					prevPath: backUrl,
				},
			});
		}
	};

	useEffect(() => {
		const qcData = buyerList?.[idx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			qcData !== null
		) {
			const newListItem = keyPressHandler(
				keyPressed,
				buyerList,
				idx
			);
			if (newListItem) {
				history.push({
					pathname: `${urls.EXTENSION}${urls.BUYER_SALES_DETAILS}`,
					search: `poId=${newListItem?.id}&clientPoId=${newListItem?.clientPoId}`,
					state: {
						prevPath: backUrl,
					},
				});
			}
		}
	}, [keyPressed]);

	//  orderProducts Tab
	const colMapOrderProducts = {
		'Variant Name': 'id',
		Unit: 'id',
		'Category Name': 'id',
		'Sub Category': 'id',
		'SKU Code': 'id',
		'Ordered Quantity': 'id',
		Fulfilled: 'id',
		Returned: 'id',
		'Production Plan Name': 'id',
		'Item Price': 'id',
		'Discount %': 'id',
		'Tax %': 'id',
		'Tax value': 'id',
		'Total Item Amount': 'id',
	};

	const SPECIAL_COLUMNS = [
		{
			title: 'Variant Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Unit',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Category Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Sub Category',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'SKU Code',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Ordered Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Fulfilled',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Returned',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Production Plan Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Item Price',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Discount %',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Tax %',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Tax value',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Total Item Amount',
			config: {
				type: 'DATA',
			},
		},
	];

	const orderSpecialMapping = {
		'Variant Name': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				<div className='text-left '>
					<span className='text-[12px] text-nowrap'>
						{item?.productName +
							(item?.variantName
								? ` (${item?.variantName})`
								: '')}
					</span>
					<span className='text-[12px]'>{item?.description ? item?.description : ''}</span>
				</div>
			);
		},
		Unit: (itemId, value) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemUnit = item?.unit;
			if (baseUnits?.includes(itemUnit)) {
				return getUnitConvertedUnit(item?.qty, itemUnit);
			}
			return <span className='text-[12px] text-left'>{itemUnit}</span>;
		},
		'Category Name': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{item?.categoryName ?? '-'}</span>;
		},
		'Sub Category': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{products?.find((product) => product?.id === item?.productId)?.subCategoryName ? products?.find((product) => product?.id === item?.productId)?.subCategoryName : item?.subCategoryName ?? '-'}</span>;
		},
		'SKU Code': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{item?.clientVariantId ? item?.clientVariantId : products.find((product) => product?.id === item?.productId)?.variants?.find((variant) => variant?.id === item?.variantId)?.clientVariantId ?? '-'}</span>;
		},
		'Ordered Quantity': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const poItem = po?.items?.find((i) => {
				return item.variantId === i?.variantId;
			});
			const itemQty = poItem?.qty ?? item?.qty;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemQty,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemQty}</span>;
		},
		Fulfilled: (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemFulfilled = item?.fulfilled;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemFulfilled,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemFulfilled}</span>;
		},
		Returned: (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemReturned = item?.returned;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemReturned,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemReturned}</span>;
		},
		'Production Plan Name': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			// return item?.poId ?? '-';
			return <span className='text-[12px] text-left'>{item?.clientPoId ?? '-'}</span>;
		},
		'Tax value': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			let itemQty = item?.qty;
			if (baseUnits?.includes(item?.unit)) {
				itemQty = getUnitConvertedUnit(itemQty, item?.unit);
			}
			let itemPrice = item?.price;
			if (item?.unit === 'gram' || item?.unit === 'ml') {
				itemPrice /= 1000;
			}
			if (item?.unit === 'oz') {
				itemPrice /= 16;
			}
			if (item?.unit === 'floz') {
				itemPrice /= 128;
			}
			const percentageValue =
				(itemPrice * itemQty * item?.taxPercentage) / 100;
			if (!item?.productTaxValue) {
				return (
					<span className='text-[12px] text-left'>
						₹
						{addCommas(percentageValue)}
					</span>
				);
			}
			return <span className='text-[12px] text-left'>{`₹${addCommas(item?.productTaxValue)}` ?? '-'}</span>;
		},
		'Item Price': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				<span className='text-[12px] text-left'>
					₹
					{item?.productCost ?? item?.price ?? '-'}
				</span>
			);
		},
		'Discount %': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{item?.discountPercentage ?? '-'}</span>;
		},
		'Tax %': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{`${item?.taxPercentage}%` ?? '-'}</span>;
		},
		'Total Item Amount': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{`₹${addCommas(item?.totalValue ?? item?.finalAmount)}` ?? '-'}</span>;
		},
	};

	const infoSpecialFeild = {
		'PO Type': (id, item) => {
			const generationType = item?.jsonData?.deltaType;
			if (!generationType) return <p className='text-[14px] font-semibold'>Regular</p>;
			if (generationType === 'UNDER_RECEIVING') {
				return (
					<p className='text-red-700 text-[14px] '>
						Under Reciving
					</p>
				);
			}
			if (generationType === 'EXCESS_RECEIVING') {
				return (
					<p className='text-red-700 text-[14px]'>
						Excess Reciving
					</p>
				);
			}
		},
		'Order Value': (id, item) => {
			const orderAmount =
				item?.finalValue == 0 ? item?.orderValue : item?.finalValue;
			return (
				<p className='text-[14px] font-semibold'>
					₹
					{orderAmount >= 0 ? addCommas(orderAmount) : '-'}
					{getPODeltas(item)}
				</p>
			);
		},
	};

	// shipment Tab
	const shipmentColumns = [
		{
			title: 'Shipment Id',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatch Date',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Receiving Date',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Shipment Type',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Vehicle Number',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Delivery Charges',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Planned Amount',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatch Amount',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Status',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'More',
			config: {
				type: 'DATA',
			},
		},
	];

	// shipment colMap
	const shipmentColMap = {
		'Shipment Id': 'id',
		'Dispatch Date': 'dispatchDate',
		'Receiving Date': 'receivingDate',
		'Shipment Type': 'shipmentType',
		'Vehicle Number': 'transVehicleNo',
		'Delivery Charges': 'deliveryCharges',
		'Planned Amount': 'qtyValue',
		'Dispatch Amount': 'dispatchedValue',
		Status: 'status',
	};

	// shipment specialMappings
	const shipmentSpecialMappings = {
		'Shipment Id': (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		'Dispatch Date': (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		'Receiving Date': (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		'Shipment Type': (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		'Vehicle Number': (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		Status: (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		'Delivery Charges': (id, items) => {
			return <p className='text-[12px] text-left'>{items ?? '-'}</p>;
		},
		'Planned Amount': (id, items) => {
			return <p className='text-[12px] text-left'>{items?.toFixed(2) ?? '-'}</p>;
		},
		'Dispatch Amount': (id, items) => {
			return <p className='text-[12px] text-left'>{items?.toFixed(2) ?? '-'}</p>;
		},
		More: (id, items) => {
			return (
				<ExternalLink
					size={16}
					className='text-[12px] text-left cursor-pointer hover:text-[#4a70fb]'
					onClick={() => {
						history.push({
							pathname: `${urls.EXTENSION}${urls.SHIPMENT_DETAILS}`,
							search: `?id=${id}&type=buyer`,
							state: {
								prevPath: location.pathname + location.search,
							},
						});
					}}
				/>
			);
		},
	};

	return (
		<>
			<DocumentModal />
			<CreateShipmentModal
				fetchPo={afterShipmentSave}
				shipmentMode='buyer'
			/>
			<FileUploaderModal handleConfirm={handleDocUpload} />
			<AlertModal />
			<GrnHeader
				title='Back to Buyer Sales Orders'
				navigateLabel='Refence Buyer ID'
				id={poId}
				navigatePrevToolTip='Prev Buyer'
				navigateNextToolTip='next Buyer'
				navigateQC={navigateQc}
				listData={buyerList}
				idx={idx}
				url={backUrl}
			/>
			<div className='relative top-[3rem] p-4'>
				<Info
					buttons={handleButtons()}
					fieldMap={fieldsMap}
					data={poInfo}
					specialFields={infoSpecialFeild}
					heading={
						{
							key: 'PO Status',
							value: handleOrderStatus(po?.orderStatus),
						}
					}
				/>
				<Tab
					tabList={tabList}
					tabValue={tabValue}
					handleTabChange={handleTabChange}
				/>
				{tabValue === 'orderedProducts' && (
					<div className='overflow-auto'>
						<GrnTable
							data={data}
							colMap={colMapOrderProducts}
							special={SPECIAL_COLUMNS}
							specialMappings={orderSpecialMapping}
							tableType='orderedProducts'
						/>
					</div>
				)}
				{tabValue === 'shipment' && (
					<GrnTable
						data={shipmentList?.data}
						colMap={shipmentColMap}
						special={shipmentColumns}
						specialMappings={shipmentSpecialMappings}
						tableType='shipment'
					/>
				)}
				{tabValue === 'documents' && (
					<DocumentsImagesSection
						documents={data}
						handlePreview={handleViewDoc}
					/>
				)}
			</div>
		</>
	);
}

export default BuyerSalesDetails;
